import { Message } from 'common/infrastructure/bus';
import { IEvent } from 'common/infrastructure/event.bus';
import { AssetUpdatedEvent } from '@planitgeo/treeplotter-domain/lib/modules/asset-class/asset/domain/event/asset-updated.event';
import { FieldSyncAssetUpdatedEvent } from '@planitgeo/treeplotter-domain/lib/modules/asset-class/asset/domain/event/field-sync-asset-updated.event';
import loggerService, { LoggerLevel } from 'common/infrastructure/log';

export const processEvent = async (
  event: Message<IEvent<AssetUpdatedEvent | FieldSyncAssetUpdatedEvent>>
) => {
  loggerService.log(LoggerLevel.INFO, 'Asset updated', event.data.payload);
};
